// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__UBKuP","bigColWidth":"Table_bigColWidth__2TS6y","biggerColWidth":"Table_biggerColWidth__1rU-5","row":"Table_row__2F-B_","col":"Table_col___z9ml"};